import { render, staticRenderFns } from "./vip-content.vue?vue&type=template&id=0d95abe2&scoped=true&"
import script from "./vip-content.vue?vue&type=script&lang=js&"
export * from "./vip-content.vue?vue&type=script&lang=js&"
import style0 from "./vip-content.vue?vue&type=style&index=0&id=0d95abe2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d95abe2",
  null
  
)

export default component.exports